const STORAGE_KEY = "ez_build_chunk_reloads"
const WINDOW_MS = 60_000
const MAX_RELOADS = 2
const SETTLE_MS = 15_000

const readAttempts = (): number[] => {
  try {
    const parsed: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? "[]")
    return Array.isArray(parsed)
      ? parsed.filter((entry): entry is number => typeof entry === "number")
      : []
  } catch {
    return []
  }
}

// Storage throws in private mode and inside sandboxed frames; a reload guard
// that raises would re-enter the very handlers it is meant to bound.
const writeAttempts = (attempts: number[]): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attempts))
  } catch {
    /* empty */
  }
}

const clearAttempts = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* empty */
  }
}

// Rendered without React on purpose: this path exists precisely because the
// app's own chunks cannot be loaded.
const showUnrecoverableNotice = (): void => {
  if (document.getElementById("chunk-load-failure")) {
    return
  }

  const wrap = document.createElement("div")
  wrap.id = "chunk-load-failure"
  wrap.setAttribute("role", "alert")
  wrap.style.cssText =
    "position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;" +
    "justify-content:center;background:#fff;font-family:system-ui,sans-serif;padding:24px"

  const card = document.createElement("div")
  card.style.cssText = "max-width:420px;text-align:center;color:#1f2933"

  const title = document.createElement("h1")
  title.textContent = "Couldn't load the app"
  title.style.cssText = "font-size:20px;margin:0 0 8px"

  const body = document.createElement("p")
  body.textContent =
    "Some application files are unavailable. This usually clears after a moment — if it keeps happening, please contact support."
  body.style.cssText = "font-size:14px;line-height:1.5;margin:0 0 20px;color:#52606d"

  const retry = document.createElement("button")
  retry.type = "button"
  retry.textContent = "Try again"
  retry.style.cssText =
    "background:#2A7D8C;color:#fff;border:0;border-radius:6px;padding:10px 20px;" +
    "font-size:14px;cursor:pointer"
  retry.addEventListener("click", () => {
    clearAttempts()
    window.location.reload()
  })

  card.append(title, body, retry)
  wrap.append(card)
  document.body.append(wrap)
}

export const reloadForChunkError = (): void => {
  const now = Date.now()
  const recent = readAttempts().filter((attempt) => now - attempt < WINDOW_MS)

  if (recent.length >= MAX_RELOADS) {
    showUnrecoverableNotice()
    return
  }

  writeAttempts([...recent, now])
  window.location.reload()
}

// A boot that stays up this long fetched its chunks, so a later stale-chunk
// reload after a real deploy starts from a full budget instead of inheriting
// the previous session's attempts.
export const scheduleChunkReloadReset = (): void => {
  window.setTimeout(clearAttempts, SETTLE_MS)
}
